export interface TaxPolicy {
  id: string;
  title: string;
  documentNumber: string;
  category: string;
  issuingAuthority: string;
  publishDate: string;
  effectiveDate: string;
  status: string;
  matchScore: number;
  matchReason: string;
  summary: string;
  keyPoints: string[];
  impact: string;
}

const NOT_APPLICABLE = /不适用|不匹配|不符合|不相关|无关|排除/;

/** 模型给的是文字状态，不是百分比。只保留已判定符合的政策，并换成匹配度。 */
export function matchPercentFromStatus(status: string): number | null {
  const text = (status || '').trim();
  if (!text || NOT_APPLICABLE.test(text)) return null;
  if (/待核实|待核验|待确认|未知/.test(text)) return null;
  if (/高度匹配|高相关|完全匹配/.test(text)) return 94;
  if (/部分匹配/.test(text)) return 70;
  if (/条件匹配/.test(text)) return 78;
  if (/匹配/.test(text)) return 88;
  return null;
}
